import { render, staticRenderFns } from "./TrustedCompanies.vue?vue&type=template&id=7c23eca1&scoped=true"
import script from "./TrustedCompanies.vue?vue&type=script&lang=js"
export * from "./TrustedCompanies.vue?vue&type=script&lang=js"
import style0 from "./TrustedCompanies.vue?vue&type=style&index=0&id=7c23eca1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c23eca1",
  null
  
)

export default component.exports